// Turkish translations for mobile app
export const tr = {
  // Common
  welcome: "Hoş Geldiniz",
  next: "İleri",
  back: "Geri",
  submit: "Gönder",
  cancel: "İptal",
  loading: "Yükleniyor...",
  error: "Hata",
  success: "Başarılı",
  and: "ve",

  // Auth
  login: "Giriş Yap",
  register: "Kayıt Ol",
  email: "E-posta",
  password: "Şifre",
  firstName: "Ad",
  lastName: "Soyad",
  forgotPassword: "Şifremi Unuttum?",

  // Validation Messages
  fieldRequired: "Bu alan zorunludur",
  emailRequired: "E-posta adresi gereklidir",
  passwordRequired: "Şifre gereklidir",
  invalidEmail: "Lütfen geçerli bir e-posta adresi girin",
  passwordTooShort: "Şifre en az 6 karakter olmalıdır",

  // Login & Auth UI
  welcomeBack: "Tekrar Hoş Geldiniz",
  signInToContinue: "Devam etmek için giriş yapın",
  rememberMe: "Beni hatırla",
  loginWith: "İle giriş yap",
  dontHaveAccount: "Hesabınız yok mu?",
  orContinueWith: "veya şununla devam edin",
  enterEmail: "E-posta adresinizi girin",
  enterPassword: "Şifrenizi girin",

  // Register UI
  createAccount: "Hesap Oluştur",
  signUpToGetStarted: "Başlamak için kayıt olun",
  joiningCompany: "Şirkete katılıyorsunuz",
  fullName: "Ad Soyad",
  enterName: "Adınızı ve soyadınızı girin",
  confirmPassword: "Şifreyi Onayla",
  reEnterPassword: "Şifrenizi tekrar girin",
  iAgreeToThe: "Kabul ediyorum",
  termsOfService: "Kullanım Şartları",
  privacyPolicy: "Gizlilik Politikası",
  alreadyHaveAccount: "Zaten hesabınız var mı?",
  nameMinLength: "İsim en az 2 karakter olmalıdır",
  passwordsDoNotMatch: "Şifreler eşleşmiyor",
  mustAgreeToTerms: "Kullanım Şartları ve Gizlilik Politikasını kabul etmelisiniz",
  signIn: "Giriş Yap",

  // Liveness Check
  moveFaceIntoFrame: "Yüzünüzü çerçeveye alın",
  livenessSmile: "Lütfen geniş bir şekilde gülümseyin",
  livenessBlink: "Lütfen gözlerinizi kırpın",
  livenessTurnLeft: "Başınızı sola çevirin",
  livenessTurnRight: "Başınızı sağa çevirin",
  multipleFacesDetected: "Sadece bir kişi olmalı",
  captureError: "Görüntü yakalanamadı",
  verifying: "Doğrulanıyor...",
  smile: "Gülümseyin",
  turnLeft: "Sola Dönün",
  turnRight: "Sağa Dönün",
  blink: "Göz Kırpın",

  // API & Errors
  unknownError: "Bilinmeyen bir hata oluştu.",
  apiConnectionError: "API bağlantı hatası",
  unknown3DLivenessError: "Bilinmeyen 3D canlılık hatası",
  livenessVerificationFailed: "Canlılık doğrulaması başarısız. Lütfen tekrar deneyin.",
  networkError: "Ağ hatası. Lütfen bağlantınızı kontrol edin.",
  nA: "Yok",
  unknown: "Bilinmeyen",

  // Super Admin Panel
  totalUsers: "Toplam Kullanıcılar",
  companies: "Şirketler",
  submissions: "Gönderimler",
  pendingReview: "İnceleme Bekliyor",
  userManagement: "Kullanıcı Yönetimi",
  allSubmissions: "Tüm Gönderimler",
  systemHealth: "Sistem Sağlığı",
  alerts: "Uyarılar",
  systemSettings: "Sistem Ayarları",
  languageSettings: "Dil Ayarları",
  analytics: "Analitik",
  securityLogs: "Güvenlik ve Loglar",
  superAdminPanel: "Süper Admin Paneli",
  manageYourPlatform: "Tüm platformunuzu yönetin",
  loadingDashboard: "Dashboard yükleniyor...",
  navigationError: "Bu ekrana gidilemiyor.",
  retry: "Tekrar Dene",
};
